export default "__VITE_ASSET__5XwthS5B__"